module.exports = __webpack_public_path__ + "static/media/external-link-square.062c424d.svg";